import React from 'react';
import RecipientsProvider from './RecipientsProvider';
import EmailSelection from './EmailSelection';

export type EmailListConfigurationOwnProps = {
    medicalProfileId: string | null;
    value: string[];
    onChange: (emails: string[]) => void;
};

export type EmailListConfigurationProps = EmailListConfigurationOwnProps;

const EmailListConfiguration: React.FC<EmailListConfigurationProps> = (props) => {
    if (props.medicalProfileId) {
        return (
            <RecipientsProvider medicalProfileId={props.medicalProfileId}>
                {({ recipients }) => (
                    <EmailSelection recipients={recipients} value={props.value} onChange={props.onChange} />
                )}
            </RecipientsProvider>
        );
    } else {
        return <EmailSelection recipients={[]} value={props.value} onChange={props.onChange} />;
    }
};

export default React.memo(EmailListConfiguration);
